import { GridFilterInputValueProps } from '@mui/x-data-grid-premium'
import { Dropdown } from '~/@/components/inputs/selection/dropdown'
import { normalizeOption, Option } from '~/@/components/inputs/selection/utils'
/**
 * Wrapper component for single-select Selector to handle MUI Grid filter props
 */
export function CustomSingleSelectFilterInput(
  props: GridFilterInputValueProps & {
    options: string[] | Option[]
    disabled: boolean
  },
) {
  const { item, applyValue, options, disabled } = props

  return (
    <Dropdown
      className="h-9 text-xs"
      disabled={disabled}
      onChange={(value) => {
        applyValue({ ...item, value: value ?? undefined })
      }}
      options={options.map(normalizeOption)}
      value={item.value ?? ''}
    />
  )
}
